var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Defaults, Watch, PropertyConverters, ViewChild, Utils, Components, UI } from '@pacem/pacem-core';
import { Components as ScaffoldingComponents } from '@pacem/pacem-scaffolding';
import { Functions, EXPRESSION_METADATA_TYPE } from '../../scaffolding/types';
import { EXPRESSION_WIDGET_METADATA_EXTRA, gridifyMetadata } from '../types';
//namespace Pacem.Components.Cms {
/** Default metadata ('expression' field) 'type' factory. */
export const DATACOLUMNS_METADATA_TYPE = (host, hostRef = ':host', hostEntityRef = ':host.entity') => {
    const attrs = {}, meta = host.metadata, fns = Functions, fnKeys = [];
    attrs['properties'] = `{{ Pacem.CustomElementUtils.getWatchedProperty(${hostEntityRef}, '${meta.prop}').config.converter }}`;
    const tagName = P + '-datacolumns';
    let extra = (meta.extra || {});
    // properties
    if (!Utils.isNullOrEmpty(extra.properties)) {
        switch (typeof extra.properties) {
            case 'string':
                attrs['properties'] = `{{ ${hostEntityRef}.${extra.properties} }}`;
                break;
            case 'function':
                const fnKey = 'fn' + Utils.uniqueCode();
                fns[fnKey] = extra.properties;
                attrs['properties'] = `{{ Pacem.Components.Cms.Functions.${fnKey}(${hostRef}), once }}`;
                // tidy-up memento
                fnKeys.push(fnKey);
                break;
        }
    }
    if (fnKeys.length > 0) {
        // tidy-up
        attrs['on-unload'] = `{{ Pacem.Components.Cms.Functions.dismiss('${fnKeys.join('\',\'')}') }}`;
    }
    return { tagName: tagName, attrs: attrs };
};
const DATACOLUMN_METADATA = {
    display: { name: 'Columns' },
    props: [
        { prop: 'header', type: 'string', display: { cssClass: ['form-minimal'], name: 'Header' } },
        {
            prop: 'content', type: EXPRESSION_METADATA_TYPE, display: { name: 'Content' },
            extra: EXPRESSION_WIDGET_METADATA_EXTRA
        }
    ]
};
let PacemDataColumnElement = class PacemDataColumnElement extends Components.PacemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'content':
                this.contentExpression = val;
                break;
            case 'contentExpression':
                this.setAttribute('content', val || '');
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._form.entity = this;
        this._form.metadata = gridifyMetadata(DATACOLUMN_METADATA);
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemDataColumnElement.prototype, "header", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemDataColumnElement.prototype, "content", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemDataColumnElement.prototype, "contentExpression", void 0);
__decorate([
    ViewChild(P + '-form')
], PacemDataColumnElement.prototype, "_form", void 0);
PacemDataColumnElement = __decorate([
    CustomElement({
        tagName: P + '-widget-datacolumn', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-form class="panel-body" autogenerate="true"></${P}-form>`
    })
], PacemDataColumnElement);
export { PacemDataColumnElement };
let PacemDataColumnsElement = class PacemDataColumnsElement extends ScaffoldingComponents.Scaffolding.PacemBaseElement {
    constructor() {
        super(...arguments);
        this._dropHandler = (e) => {
            this.changeHandler(e);
        };
        this._columnifyMetadata = (props = this.properties) => {
            return (props || []).map(p => {
                const header = typeof p.display?.name === 'function' ? /* NOT supported */ p.prop : (p.display?.name || p.prop);
                const c = {
                    header,
                    content: `{{ ^item.${p.prop} }}`
                };
                return c;
            }).sort((a, b) => a.header > b.header ? 1 : -1);
        };
    }
    get inputFields() {
        return [];
    }
    toggleReadonlyView(readonly) {
        // leave it all to the template bindings
    }
    onChange(evt) {
        return Utils.fromResult(this.value = this._repeater.datasource);
    }
    acceptValue(val) {
        if (!Utils.isNull(this._repeater)) {
            this._repeater.datasource = Utils.clone(val || []);
        }
    }
    getViewValue(value) {
        return /* dummy */ '[DataColumns]';
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Json.convert(attr, this);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._propDragger.addEventListener(UI.DragDropEventType.End, this._dropHandler, false);
        this._colDragger.addEventListener(UI.DragDropEventType.End, this._dropHandler, false);
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._propDragger)) {
            this._propDragger.removeEventListener(UI.DragDropEventType.End, this._dropHandler, false);
        }
        if (!Utils.isNull(this._colDragger)) {
            this._colDragger.removeEventListener(UI.DragDropEventType.End, this._dropHandler, false);
        }
        super.disconnectedCallback();
    }
};
__decorate([
    ViewChild(`${P}-repeater[columns]`)
], PacemDataColumnsElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(`${P}-drag-drop[properties]`)
], PacemDataColumnsElement.prototype, "_propDragger", void 0);
__decorate([
    ViewChild(`${P}-drag-drop[columns]`)
], PacemDataColumnsElement.prototype, "_colDragger", void 0);
__decorate([
    ViewChild('div[drop-target]')
], PacemDataColumnsElement.prototype, "_dropTarget", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemDataColumnsElement.prototype, "properties", void 0);
PacemDataColumnsElement = __decorate([
    CustomElement({
        tagName: P + '-widget-datacolumns', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-datacolumns">
    <div class="datacolumns-main display-flex flex-fill">

        <${P}-drag-drop mode="${UI.DragDataMode.Alias}" disabled="{{ :host.readonly }}" handle-selector="*[handle]"
              drop-behavior="${UI.DropBehavior.InsertChild}" drop-targets="{{ [::_dropTarget] }}" columns></${P}-drag-drop>
        <${P}-repeater class="display-flex flex-fill" columns>
            <!-- columns -->
            <div class="display-flex flex-nowrap" drop-target>
                <template>
                    <${P}-panel behaviors="{{ [::_colDragger] }}">
                        <div class="${PCSS}-panel panel-side-left side-auto">
                            <div class="panel-side">
                                <${P}-button class="display-block button-flat icon-glyph-small" icon-glyph="drag_indicator" handle></${P}-button>
                                <${P}-button class="display-block button-flat icon-glyph-small" on-click=":host.value.splice(^index, 1)" icon-glyph="clear"></${P}-button>
                            </div>
                            <div class="panel-heading">
                                <${P}-text text="{{ ^item.header }}"></${P}-text>
                            </div>
                            <${P}-widget-datacolumn class="panel-body" header="{{ ^item.header, twoway }}" content-expression="{{ ^item.content, twoway }}"></${P}-widget-datacolumn>
                        </div>
                    </${P}-panel>
                </template>
            </div>
        </${P}-repeater>

    </div>
    <${P}-panel class="datacolumns-props" hide="{{ :host.readonly }}">
        <${P}-drag-drop mode="${UI.DragDataMode.Copy}" disabled="{{ :host.readonly }}" handle-selector="*[handle]"
              drop-behavior="${UI.DropBehavior.InsertChild}" drop-targets="{{ [::_dropTarget] }}" properties></${P}-drag-drop>
        <${P}-repeater datasource="{{ :host._columnifyMetadata(:host.properties) }}">
        <!-- properties -->
            <template>
                <${P}-panel behaviors="{{ [::_propDragger] }}" class="${PCSS}-panel panel-side-left side-auto panel-primary panel-filled ${PCSS}-margin margin-bottom-1">
                    <div class="panel-side">
                        <${P}-button class="display-block button-flat icon-glyph-small" icon-glyph="drag_indicator" handle></${P}-button>
                    </div>
                    <div class="text-truncate panel-body">
                        <${P}-span text="{{ ^item.header }}"></${P}-span>
                    </div>
                </${P}-panel>
            </template>
        </${P}-repeater>
    </${P}-panel>
</div>`
    })
], PacemDataColumnsElement);
export { PacemDataColumnsElement };
